import * as React from "react";
import {
  Box,
  Grid,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { snakeCaseToTitleCase } from "../../utils/CaseFormatHelper";
import DeleteIcon from "@mui/icons-material/Delete";
import CoreTeamCustomerAssociationModalNew from "./CoreTeamCustomerAssociationModalNew";
import CoreTeamCustomerAssociationModalDelete from "./CoreTeamCustomerAssociationModalDelete";

// heplers
import { PrivilegesContext } from "../../PrivilegesContext";
import { checkPrivileges } from "../../utils/PrivilegesHelper";

// auth helpers
import { getHeaders } from "../../utils/HeaderHelper";
import { AuthenticationContext, ImagesContext } from "../../Context";

interface Props {
  csrfToken: string;
  selectedProvider: any;
  menu_track_src: string;
}

const CoreTeamCustomerAssociation: React.FC<Props> = (props: any) => {
  // authentication context
  const authenticationSetting = React.useContext(AuthenticationContext);
  const images = React.useContext(ImagesContext);

  // other states
  const [customerAssociations, setCustomerAssociations] =
    React.useState<any>(null);
  const [associationModalOpen, setAssociationModalOpen] =
    React.useState<boolean>(false);
  const [deleteModalHandler, setDeleteModalHandler] = React.useState<any>({
    open: false,
    customerUserId: null,
  });
  const [deleteable, setDeleteable] = React.useState<boolean>(false);
  const userPrivileges = React.useContext(PrivilegesContext);

  const getCustomerUsers = () => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    fetch(
      `/data_fetching/core_team_customer_association_index/${props.selectedProvider?.user_id}?tz=${tz}`,
      {
        method: "GET",
        headers: getHeaders(authenticationSetting.csrfToken),
      }
    )
      .then((result) => result.json())
      .then((result) => {
        if (result.success == false) {
          console.log(result.error);
        } else {
          setCustomerAssociations(result?.resource?.customer_associations);
          setDeleteable(result?.resource?.deletable);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  React.useEffect(() => {
    getCustomerUsers();
  }, [props.selectedProvider]);

  const handleModalOpen = () => {
    event.preventDefault();
    setAssociationModalOpen(true);
  };

  const unassingCustomerUser = (customerUserId) => {
    setDeleteModalHandler({ open: true, customerUserId: customerUserId });
  };

  const statusClassMap: { [key: string]: string } = {
    pending: "status-badge status-badge--pending",
    accepted: "status-badge status-badge--accepted",
    inactive: "status-badge status-badge--inactive",
  };

  return (
    <Grid
      item
      xs={12}
      height="483px"
      sx={{ backgroundColor: "white" }}
      className="provider-association-history-container"
    >
      <Box className="top-header-box">
        <Typography className="top-heading">
          Provider Association History
        </Typography>
        {checkPrivileges(
          userPrivileges,
          "Edit Provider Organization Associations"
        ) &&
        !props.selectedProvider?.starfield_admin && (
          <Link className="row" onClick={handleModalOpen}>
            <img
              src={images.add_icon}
              alt="Add Charge"
              className="action-icon-image"
              style={{ width: 20, maxHeight: 20 }}
            />
            <span className="add-btn-text">Add Association</span>
          </Link>
        )}
      </Box>

      <TableContainer className="provider-association-history-table-container">
        <Table stickyHeader className="provider-association-history-table">
          <TableHead className="table-header">
            <TableRow>
              <TableCell align="left">Organization</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="left">Added By</TableCell>
              <TableCell align="left">Timestamp</TableCell>
              <TableCell align="left"></TableCell>
            </TableRow>
          </TableHead>

          {customerAssociations?.map((customerUser) => (
            <TableBody>
              <TableRow>
                <TableCell align="left">{customerUser.customer_name}</TableCell>
                <TableCell align="center">
                  <div className={statusClassMap[customerUser.status] || ""}>
                    {snakeCaseToTitleCase(
                      customerUser.status == "accepted"
                        ? "active"
                        : customerUser.status
                    )}
                  </div>
                </TableCell>
                <TableCell align="left">{customerUser.added_by}</TableCell>
                <TableCell align="left">
                  <span>{customerUser?.formatted_assigned_at} </span>{" "}
                  <span
                    style={{
                      display: "inline-block",
                      marginLeft: 10,
                    }}
                  >
                    {customerUser?.formatted_assigned_at_time}
                  </span>
                </TableCell>
                <TableCell>
                  {customerUser.status != "inactive" &&
                    checkPrivileges(
                      userPrivileges,
                      "Edit Provider Organization Associations"
                    ) &&
                    deleteable && (
                      <DeleteIcon
                        className="delete-icon"
                        onClick={() => {
                          unassingCustomerUser(customerUser.id);
                        }}
                      />
                    )}
                </TableCell>
              </TableRow>
            </TableBody>
          ))}
        </Table>
      </TableContainer>

      <CoreTeamCustomerAssociationModalNew
        csrfToken={props.csrfToken}
        selectedProvider={props.selectedProvider}
        menu_track_src={props.menu_track_src}
        getCustomerUsers={getCustomerUsers}
        setAssociationModalOpen={setAssociationModalOpen}
        associationModalOpen={associationModalOpen}
      />

      <CoreTeamCustomerAssociationModalDelete
        csrfToken={props.csrfToken}
        deleteModalHandler={deleteModalHandler}
        setDeleteModalHandler={setDeleteModalHandler}
        getCustomerUsers={getCustomerUsers}
      />
    </Grid>
  );
};

export default CoreTeamCustomerAssociation;
